import { Link } from "react-router-dom";
import { Calculator, Gauge, Grid3X3, ArrowRight } from "lucide-react";
import { useSEO } from "../lib/seo";

const tools = [
  { to: "/tools/route-profitability-calculator", icon: Calculator, title: "Route Profitability Calculator", desc: "Model revenue, chemicals, labor and drive time per route. Find your real margin per route day and per stop.", id: "route" },
  { to: "/tools/technician-capacity-estimator", icon: Gauge, title: "Technician Capacity Estimator", desc: "Calculate how many stops a tech can realistically handle per day and per week — before you hire.", id: "capacity" },
  { to: "/tools/integration-matrix", icon: Grid3X3, title: "Integration Matrix", desc: "See which pool software platforms connect to QuickBooks, Stripe, Zapier, SMS, and more — side by side.", id: "matrix" },
];

export default function Tools() {
  useSEO({
    title: "Free Tools for Pool Service Companies",
    description: "Free calculators for pool service businesses: route profitability, technician capacity, and a software integration matrix.",
  });

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16" data-testid="tools-page">
      <p className="uppercase tracking-[0.2em] text-xs font-semibold text-sky-600 mb-2">Free forever</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-slate-900">Tools for Pool Pros</h1>
      <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">Run the numbers on your own business before spending a dollar on software. No signup required.</p>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {tools.map((t) => (
          <Link key={t.id} to={t.to} data-testid={`tool-card-${t.id}`}
            className="group bg-white rounded-2xl border border-border p-8 hover:border-sky-300 hover:shadow-lg hover:shadow-sky-100 transition-shadow duration-200 flex flex-col">
            <span className="w-12 h-12 rounded-xl bg-sky-50 text-sky-600 flex items-center justify-center mb-5 group-hover:bg-sky-500 group-hover:text-white transition-colors duration-200">
              <t.icon className="w-6 h-6" aria-hidden="true" />
            </span>
            <h2 className="font-heading font-bold text-lg text-slate-900">{t.title}</h2>
            <p className="text-sm text-slate-500 mt-2 leading-relaxed flex-1">{t.desc}</p>
            <span className="inline-flex items-center gap-1 mt-5 text-sm font-semibold text-sky-600">Open tool <ArrowRight className="w-4 h-4" aria-hidden="true" /></span>
          </Link>
        ))}
      </div>
    </div>
  );
}
